import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { Text } from '@chakra-ui/react';

const GroupsSearch = ({ items, setResult, defaultValue }) => {
  // note: the id field is mandatory

  const handleOnSearch = (string, results) => {
    console.log(string, results);
  };

  const handleOnHover = result => {};

  const handleOnSelect = item => {
    setResult(item.id);
  };

  const handleOnFocus = () => {
    console.log('Focused');
  };

  const formatResult = item => {
    return (
      <>
        <span style={{ display: 'block', textAlign: 'left' }}>
          id: {item.id}
        </span>
        <span style={{ display: 'block', textAlign: 'left' }}>
          name: {item.name}
        </span>
      </>
    );
  };

  return (
    <div
      style={{
        width: 400,
        marginTop: '8px',
        marginBottom: '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Text>Группа</Text>
      <ReactSearchAutocomplete
        inputSearchString={defaultValue}
        items={items}
        onSearch={handleOnSearch}
        onHover={handleOnHover}
        onSelect={handleOnSelect}
        onFocus={handleOnFocus}
        autoFocus
        formatResult={formatResult}
        showIcon={false}
        styling={{ borderRadius: '8px', zIndex: 99998 }}
        maxResults={10}
      />
    </div>
  );
};

export default GroupsSearch;
